import React, { useRef, useMemo, useEffect, useState } from 'react'
import useWS, { ReadyState } from 'react-use-websocket'


const useWebSocket = ({ url, skip, mock, disableReconnect = false, saveMessages, modifyResult }) => {
  const [ connectionCount, setConnectionCount ] = useState(0)

  const messages = useRef([])
  const lastMessage = useRef({})

  const {
    sendMessage,
    message,
    lastJsonMessage,
    readyState,
  } = useWS(skip ? null : url + `?connectionCount=${connectionCount}`)

  messages.current = useMemo(() => {
    if (lastJsonMessage && saveMessages) {
      if (typeof modifyResult === 'function') {
        messages.current.concat(modifyResult(lastJsonMessage))
      }
      else {
        messages.current.concat(lastJsonMessage)
      }
    }
  }, [ lastJsonMessage, saveMessages, modifyResult ])

  lastMessage.current = lastJsonMessage

  const connectionStatus = {
    [ReadyState.CONNECTING]: 'connecting',
    [ReadyState.OPEN]: 'open',
    [ReadyState.CLOSING]: 'closing',
    [ReadyState.CLOSED]: 'closed',
  }[readyState]

  const isFetching = readyState === ReadyState.CONNECTING
  const isFailed = readyState !== ReadyState.OPEN && readyState !== ReadyState.CONNECTING

  const data = mock && !isFetching ? mock : lastJsonMessage

  const timeout = useRef(null)

  useEffect(() => {
    const isRestricted = typeof lastMessage.current === 'object' && lastMessage.current && lastMessage.current.response === 'restricted'

    if (readyState === ReadyState.CLOSED && !skip && !isRestricted && disableReconnect) {
      console.error('Closed connection', url)

      if (!saveMessages) {
        timeout.current = setTimeout(() => {
          console.log('Handle reconnect', connectionCount + 1)
          setConnectionCount(connectionCount + 1)
        }, 10000)
        
        return () => {
          clearTimeout(timeout.current)
        }
      }
    }
    else {
      clearTimeout(timeout.current)
    }
  }, [ url, skip, readyState, saveMessages, disableReconnect, connectionCount ])

  return {
    connectionStatus,
    messages: messages.current,
    data: typeof modifyResult === 'function' ? modifyResult(data) : data,
    sendMessage,
    isFetching,
    isFailed,
  }
}


export default useWebSocket
